export default __webpack_public_path__ + "static/media/Capri.8eefddb4.jpg";